module.exports = __webpack_public_path__ + "static/media/icon-arrow-circular-blue.211f5784.svg";